import { vaultGetRequest } from '../helpers';
import {
  fetchImgStatusResponseSchema,
  type IFetchImgStatusResponse,
} from './fetch-img-status-response';

export async function fetchImgStatusApi(limit = 50): Promise<IFetchImgStatusResponse> {
  return vaultGetRequest({
    path: `/img/status?limit=${limit}`,
    schema: fetchImgStatusResponseSchema,
  });
}
